module.exports = __webpack_public_path__ + "8a94b667705d247ed6736ee51ca866da.MP3";